// extracted by mini-css-extract-plugin
module.exports = {"root":"_93444fe79c--root--Td7pV","link":"_93444fe79c--link--oC8uO","label":"_93444fe79c--label--MwvPk","info":"_93444fe79c--info--Y_0VH"};